// Cele 6 capitole de CITIRE ale structurii (mock-ui/structura-ierarhie-produs.md):
// numerotarea 1→19 a pașilor e ordinea de RULARE, nu de citire. Harta de pe
// Acasă și gruparea din Pipeline se desenează amândouă de aici.

import type { Cheie } from "../i18n";

export type Capitol = {
  nr: number;
  titlu: Cheie;
  intrebare: Cheie;
  granularitate: Cheie;
  // cheile pașilor din STEPS (legaturi.ts), în ordinea de citire a capitolului
  pasi: string[];
  // eticheta scurtă a fiecărui pas pe cardul capitolului
  refs: { key: string; eticheta: Cheie }[];
};

export const CAPITOLE: Capitol[] = [
  {
    nr: 1,
    titlu: "struct.cap.1.titlu",
    intrebare: "struct.cap.1.intrebare",
    granularitate: "struct.cap.1.granularitate",
    pasi: ["studiu_geotehnic", "analiza_arhitectura"],
    refs: [
      { key: "studiu_geotehnic", eticheta: "struct.cap.ref.p1_geotehnic" },
      { key: "analiza_arhitectura", eticheta: "struct.cap.ref.p2_arhitectura" },
    ],
  },
  {
    nr: 2,
    titlu: "struct.cap.2.titlu",
    intrebare: "struct.cap.2.intrebare",
    granularitate: "struct.cap.2.granularitate",
    pasi: ["strategie_arhitecturala", "model_structura"],
    refs: [
      { key: "strategie_arhitecturala", eticheta: "struct.cap.ref.p3_strategie" },
      { key: "model_structura", eticheta: "struct.cap.ref.p4_model" },
    ],
  },
  {
    nr: 3,
    titlu: "struct.cap.3.titlu",
    intrebare: "struct.cap.3.intrebare",
    granularitate: "struct.cap.3.granularitate",
    pasi: ["model_fem", "incarcari", "seism", "combinatii", "deplasari_laterale"],
    refs: [
      { key: "model_fem", eticheta: "struct.cap.ref.p7" },
      { key: "incarcari", eticheta: "struct.cap.ref.p8" },
      { key: "seism", eticheta: "struct.cap.ref.p9" },
      { key: "combinatii", eticheta: "struct.cap.ref.p11" },
      { key: "deplasari_laterale", eticheta: "struct.cap.ref.p10" },
    ],
  },
  {
    nr: 4,
    titlu: "struct.cap.4.titlu",
    intrebare: "struct.cap.4.intrebare",
    granularitate: "struct.cap.4.granularitate",
    // Armarea grinzilor de fundare stă în capitolul 5 (e „elementul"), dar
    // capitolul Fundației trimite spre ea: legătura trebuie să fie în ambele
    // sensuri, altfel cine citește talpa nu află cu ce se armează.
    pasi: ["fundatie_estimata", "rezistenta_fundatie", "verificare_fundatie"],
    refs: [
      { key: "fundatie_estimata", eticheta: "struct.cap.ref.p5_estimare" },
      { key: "rezistenta_fundatie", eticheta: "struct.cap.ref.p6_predimensionare" },
      { key: "verificare_fundatie", eticheta: "struct.cap.ref.p17_verificarea" },
      { key: "armare_fundatie", eticheta: "struct.cap.ref.p18_armarea" },
    ],
  },
  {
    nr: 5,
    titlu: "struct.cap.5.titlu",
    intrebare: "struct.cap.5.intrebare",
    granularitate: "struct.cap.5.granularitate",
    pasi: ["eforturi", "armare_grinzi", "armare_pereti", "armare_stalpi",
           "armare_placa", "armare_fundatie"],
    refs: [
      { key: "eforturi", eticheta: "struct.cap.ref.p12" },
      { key: "armare_grinzi", eticheta: "struct.cap.ref.p13" },
      { key: "armare_pereti", eticheta: "struct.cap.ref.p14" },
      { key: "armare_stalpi", eticheta: "struct.cap.ref.p15" },
      { key: "armare_placa", eticheta: "struct.cap.ref.p16" },
      { key: "armare_fundatie", eticheta: "struct.cap.ref.p18_fundare" },
    ],
  },
  {
    nr: 6,
    titlu: "struct.cap.6.titlu",
    intrebare: "struct.cap.6.intrebare",
    granularitate: "struct.cap.6.granularitate",
    pasi: ["optimizare_structura"],
    refs: [{ key: "optimizare_structura", eticheta: "struct.cap.ref.p19_cautarea" }],
  },
];
